import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  background: #a8a8b3;
  padding: 20px;
  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px 10px;
    thead {
      tr {
        th {
          color: #fff;
          font-size: 18px;
          font-weight: 500;
          text-align: left;
          padding-left: 15px;
          padding-bottom: 10px;
        }
      }
    }
    tbody {
      tr {
        background: rgb(32, 32, 36);
        border-radius: 5px;
        transition: background 0.2s ease 0s;

        td {
          color: #fff;
          padding: 10px 15px;
          font-size: 16px;

          div {
            display: flex;
            align-items: center;
          }

          &:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }
        }
      }
    }
  }
`
